module.exports = __webpack_public_path__ + "static/media/rating-star-full.695636de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wcce/rating-star-full.svg
// module id = 815
// module chunks = 0